import events from '../events/events';

const xs = 375;
const sm = 800;
const xl = 1440;
const breakpoints = [
    { name: 'xs', size: xs, media: `(max-width: ${sm - 1}px)`},
    { name: 'sm', size: sm, media: `(min-width: ${sm}px) and (max-width: ${xl - 1}px)`},
    { name: 'xl', size: xl, media: `(min-width: ${xl}px)`},
];

let current = breakpoints[0];

breakpoints.forEach((breakpoint) => {
    const mediaQuery = window.matchMedia(breakpoint.media);
    mediaQuery.addEventListener('change', (e) => {
        if (e.matches) {
            events.emit('breakpoint.change', breakpoint, current);
            current = breakpoint;
        }
    });
    if (mediaQuery.matches) {
        current = breakpoint;
    }
});

export default current;